import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import {
  Container,
  PlayerDivider,
  PlayerOne,
  PlayerTwo,
  Points,
  PointsContainer,
  Set,
  SetContainer,
  TeamName,
  TeamNameContainer,
} from './styles';

function PadelWorldPadelTour2021({ data }) {
  const { awayTeam, homeTeam, goldPoint, sets } = data;
  const isGoldPoint =
    homeTeam.points === 40 && awayTeam.points === 40 && goldPoint;

  return (
    <>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+TC&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <Container>
        <TeamNameContainer>
          <TeamName>
            <PlayerOne isServing={homeTeam.player1.isServing}>
              {homeTeam.player1.name}
            </PlayerOne>
            <PlayerDivider>/</PlayerDivider>
            <PlayerTwo isServing={homeTeam.player2.isServing}>
              {homeTeam.player2.name}
            </PlayerTwo>
          </TeamName>
          <TeamName>
            <PlayerOne isServing={awayTeam.player1.isServing}>
              {awayTeam.player1.name}
            </PlayerOne>
            <PlayerDivider>/</PlayerDivider>
            <PlayerTwo isServing={awayTeam.player2.isServing}>
              {awayTeam.player2.name}
            </PlayerTwo>
          </TeamName>
        </TeamNameContainer>
        {sets.map((set) => (
          <SetContainer key={set.id} style={{}}>
            <Set>{set.homeTeam}</Set>
            <Set>{set.awayTeam}</Set>
          </SetContainer>
        ))}
        <SetContainer last>
          <Set>{homeTeam.game}</Set>
          <Set>{awayTeam.game}</Set>
        </SetContainer>
        <PointsContainer>
          {homeTeam.ad || awayTeam.ad ? (
            <>
              <Points>{homeTeam.ad ? 'Ad' : ''}</Points>
              <Points>{awayTeam.ad ? 'Ad' : ''}</Points>
            </>
          ) : (
            <>
              <Points isGoldPoint={isGoldPoint}>{homeTeam.points}</Points>
              <Points isGoldPoint={isGoldPoint}>{awayTeam.points}</Points>
            </>
          )}
        </PointsContainer>
      </Container>
    </>
  );
}

PadelWorldPadelTour2021.propTypes = {
  data: PropTypes.shape({
    awayTeam: PropTypes.shape({
      ad: PropTypes.bool,
      game: PropTypes.number,
      player1: PropTypes.shape({
        name: PropTypes.string,
        isServing: PropTypes.bool,
      }),
      player2: PropTypes.shape({
        name: PropTypes.string,
        isServing: PropTypes.bool,
      }),
      points: PropTypes.number,
    }),
    homeTeam: PropTypes.shape({
      ad: PropTypes.bool,
      game: PropTypes.number,
      player1: PropTypes.shape({
        name: PropTypes.string,
        isServing: PropTypes.bool,
      }),
      player2: PropTypes.shape({
        name: PropTypes.string,
        isServing: PropTypes.bool,
      }),
      points: PropTypes.number,
    }),
    goldPoint: PropTypes.bool,
    sets: PropTypes.arrayOf(
      PropTypes.shape({
        awayTeam: PropTypes.number,
        homeTeam: PropTypes.number,
        id: PropTypes.string,
      })
    ),
  }),
  styles: PropTypes.shape({}),
};

PadelWorldPadelTour2021.defaultProps = {
  data: {
    awayTeam: {
      ad: false,
      game: 2,
      player1: {
        name: 'LIM',
        isServing: false,
      },
      player2: {
        name: 'TAP',
        isServing: false,
      },
      points: 15,
    },
    homeTeam: {
      ad: false,
      game: 1,
      player1: {
        name: 'LEB',
        isServing: false,
      },
      player2: {
        name: 'GAL',
        isServing: false,
      },
      points: 0,
    },
    goldPoint: true,
    sets: [{ awayTeam: 6, homeTeam: 4, id: '1' }],
  },
  styles: {},
};

export default PadelWorldPadelTour2021;
